import { useContext } from "react";

import { ThemeContext } from "@/theme/provider";
import type { ThemeContextValue } from "@/theme/provider";

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return ctx;
}
